import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import { toast } from "react-toastify";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Pagination from "../../../Components/Common/Pagination";
import { getUsers, toggleUserBlock } from "../../../slices/1-user/thunk";
import { getCategories } from "../../../slices/2-category/thunk";

const PaymentTable = () => {
  const [modal_list, setmodal_list] = useState(false);
  const dispatch = useDispatch();
  const [editModal, setEditModal] = useState(false);
  const [currentCommodity, setCurrentCommodity] = useState(null);
  const [nameAR, setNameAR] = useState("");
  const [nameEN, setNameEN] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [price, setPrice] = useState("");
  const [index, setIndex] = useState("");
  const [typeFilter, setTypeFilter] = useState(" ");

  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isBlockedStatus, setIsBlockedStatus] = useState(false);
  const [description, setDescription] = useState("");
  const [icon, setIcon] = useState("ri-folder-line");

  const iconsList = [
    "ri-shirt-line",
    "ri-shield-line",
    "ri-star-line",
    "ri-flag-line",
    "ri-global-line",
    "ri-cup-line",
  ];

  const { categories, loading, error, totalPages } = useSelector(
    (state) => state.Categories,
  );

  const [page, setPage] = useState(1);
  const limit = 10;

  useEffect(() => {
    dispatch(getCategories({ page, limit }));
  }, [dispatch, page]);

  const handleSubmit = (e) => {
    // e.preventDefault();
    // const commodityData = {
    //   name_AR: nameAR,
    //   name_EN: nameEN,
    //   price: Number(price),
    //   index: Number(index),
    // };
    // dispatch(addCommodity(commodityData))
    //   .unwrap()
    //   .then(() => {
    //     setmodal_list(false);
    //     setNameAR("");
    //     setNameEN("");
    //     setPrice("");
    //     setIndex("");
    //     dispatch(getCategories({ page, limit, search: searchTerm }));
    //   })
    //   .catch((err) => {
    //     toast.error(err?.message || "حدث خطأ", { autoClose: 3000 });
    //   });
  };

  const handleDelete = (id) => {
    if (window.confirm("هل انت متأكد من مسح المنتج؟")) {
      // dispatch(deleteCommodity(id));
    }
  };

  const confirmToggleBlock = () => {
    if (selectedUserId) {
      // console.log(selectedUserId);
      dispatch(toggleUserBlock(selectedUserId));
      setDeleteModal(false);
      setSelectedUserId(null);
    }
  };

  const openEditModal = (commodity) => {
    setCurrentCommodity(commodity);
    setNameAR(commodity.name_AR);
    setNameEN(commodity.name_EN);
    setPrice(commodity.price);
    setIndex(commodity.index);
    setEditModal(true);
  };

  const handleEditSubmit = (e) => {
    // e.preventDefault();
    // dispatch(
    //   updateCommodity({
    //     id: currentCommodity.id,
    //     data: {
    //       name_AR: nameAR,
    //       name_EN: nameEN,
    //       price: Number(price),
    //       index: Number(index),
    //     },
    //   }),
    // )
    //   .unwrap()
    //   .then(() => {
    //     setEditModal(false);
    //     dispatch(getCategories({ page, limit }));
    //   })
    //   .catch((err) => {
    //     toast.error(err?.message || "Update Failed");
    //   });
  };

  const tog_list = () => {
    setmodal_list(!modal_list);
  };

  document.title = "Payment";

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm?.length >= 3 || searchTerm?.length === 0) {
        dispatch(getCategories({ page, limit, search: searchTerm }));
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [dispatch, page, searchTerm]);

  const UserRole = [
    { value: "", label: "الكل" },
    { value: "user", label: "مستخدم" },
    { value: "owner", label: "مالك" },
    { value: "owner_store", label: "مالك متجر" },
  ];

  // console.log(selectedUserId);
  // console.log(categories);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="إدارة المدفوعات" />
          <Row>
            <Col lg={12}>
              <Card style={{ borderRadius: "16px" }}>
                <CardBody>
                  <div className="listjs-table" id="tagsList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-start">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="بحث..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </Col>
                      <Col className="col-sm" lg={3} md={4} sm={4}>
                        <div className="">
                          {/* <Label>Type </Label> */}
                          <Select
                            options={UserRole}
                            value={UserRole?.find(
                              (b) => b.value === typeFilter,
                            )}
                            onChange={(opt) => setTypeFilter(opt.value)}
                            placeholder="الكل"
                            required
                            styles={{
                              control: (base) => ({
                                ...base,
                                backgroundColor: "white",
                                color: "#212529",
                                borderColor: "#495057",
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: "white",
                              }),
                              input: (base) => ({
                                ...base,
                                color: "white",
                              }),
                              menu: (base) => ({
                                ...base,
                                backgroundColor: "white",
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isFocused
                                  ? "#bebebf"
                                  : "white",
                                color: "black",
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: "#adb5bd",
                              }),
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light text-center">
                          <tr>
                            <th>رقم</th>
                            <th>المستخدم</th>
                            <th>اسم الباقة</th>
                            <th>عدد الكوينز</th>
                            <th>المبلغ </th>
                            <th>طريقة الدفع</th>
                            <th>الحالة</th>
                            <th>التاريخ</th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all  text-center">
                          {categories && categories?.length > 0 ? (
                            categories?.map((item, index) => (
                              <tr key={item.id} className="fs-5">
                                <td className="id" style={{ display: "none" }}>
                                  <Link
                                    to="#"
                                    className="fw-medium link-primary"
                                  >
                                    {item._id}
                                  </Link>
                                </td>
                                <td className="num">
                                  <Link
                                    to="#"
                                    className="fw-medium link-primary"
                                  >
                                    {index + 1}
                                  </Link>
                                </td>
                                <td className="email">أحمد محمد</td>
                                <td className="email">حريف {index + 1}</td>
                                <td className="email">أحمد محمد</td>
                                <td className="phone">9.99</td>
                                <td className="coins">Paymob</td>
                                <td>
                                  <span
                                    className={`badge rounded-pill ${
                                      !item.isBlocked
                                        ? "bg-success"
                                        : "bg-danger"
                                    }`}
                                  >
                                    {!item.isBlocked ? "ناجح" : "فشل"}
                                  </span>
                                </td>
                                <td className="createdAt">2026-03-25</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                لا يوجد مدفوعات
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {/* Pagination */}
                    <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                      <div className="col-sm-6"></div>
                      <div className="col-sm-6">
                        <Pagination
                          currentPage={page}
                          totalPages={totalPages}
                          onPageChange={(newPage) => {
                            setPage(newPage);
                            window.scrollTo({
                              top: 0,
                              behavior: "smooth",
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add Modal */}
      <Modal isOpen={modal_list} toggle={tog_list} centered>
        <ModalHeader toggle={tog_list}>إضافة تصنيف جديد</ModalHeader>

        <form onSubmit={handleSubmit}>
          <ModalBody>
            {/* اسم التصنيف */}
            <div className="mb-3">
              <label className="form-label">اسم التصنيف</label>
              <input
                type="text"
                className="form-control"
                placeholder="مثال: الدوري الإنجليزي"
                value={nameAR}
                onChange={(e) => setNameAR(e.target.value)}
                required
              />
            </div>

            {/* الوصف */}
            <div className="mb-3">
              <label className="form-label">وصف التصنيف (اختياري)</label>
              <textarea
                className="form-control"
                placeholder="وصف مختصر للتصنيف..."
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            {/* الأيقونات */}
            <div className="mb-3">
              <label className="form-label">الأيقونة</label>

              <div className="d-flex flex-wrap gap-2">
                {iconsList.map((ic) => (
                  <div
                    key={ic}
                    onClick={() => setIcon(ic)}
                    className={`p-3 border rounded-3 text-center cursor-pointer ${
                      icon === ic ? "border-success" : ""
                    }`}
                    style={{ width: "60px", cursor: "pointer" }}
                  >
                    <i className={`${ic} fs-4`}></i>
                  </div>
                ))}
              </div>
            </div>
          </ModalBody>

          <ModalFooter>
            <button className="btn btn-light" onClick={tog_list}>
              إلغاء
            </button>
            <button type="submit" className="btn btn-success">
              حفظ
            </button>
          </ModalFooter>
        </form>
      </Modal>

      {/* Edit Modal */}
      <Modal isOpen={editModal} toggle={() => setEditModal(false)} centered>
        <ModalHeader toggle={() => setEditModal(false)}>
          تعديل التصنيف
        </ModalHeader>

        <form onSubmit={handleEditSubmit}>
          <ModalBody>
            <div className="mb-3">
              <label className="form-label">اسم التصنيف</label>
              <input
                type="text"
                className="form-control"
                value={nameAR}
                onChange={(e) => setNameAR(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">الوصف</label>
              <textarea
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">الأيقونة</label>

              <div className="d-flex flex-wrap gap-2">
                {iconsList.map((ic) => (
                  <div
                    key={ic}
                    onClick={() => setIcon(ic)}
                    className={`p-3 border rounded-3 text-center ${
                      icon === ic ? "border-success" : ""
                    }`}
                    style={{ width: "60px", cursor: "pointer" }}
                  >
                    <i className={`${ic} fs-4`}></i>
                  </div>
                ))}
              </div>
            </div>
          </ModalBody>

          <ModalFooter>
            <button className="btn btn-primary">حفظ التعديلات</button>
          </ModalFooter>
        </form>
      </Modal>

      {/* Confirm Toggle Block Modal */}
      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered>
        <ModalHeader toggle={() => setDeleteModal(false)}>
          تأكيد الإجراء
        </ModalHeader>
        <ModalBody>
          <div className="mt-2 text-center">
            <i
              className={`ri-information-line display-3 ${isBlockedStatus ? "text-success" : "text-danger"}`}
            ></i>
            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
              <h4>هل أنت متأكد؟</h4>
              <p className="text-muted mx-4 mb-0">
                هل تريد حقاً {isBlockedStatus ? "إلغاء حظر" : "حظر"} هذا
                المستخدم؟
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-center w-100">
            <Button color="light" onClick={() => setDeleteModal(false)}>
              إلغاء
            </Button>
            <Button
              color={isBlockedStatus ? "success" : "danger"}
              onClick={confirmToggleBlock}
            >
              نعم، {isBlockedStatus ? "إلغاء الحظر" : "إتمام الحظر"}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default PaymentTable;
